import React from 'react';
import '../assets/style/preloader.css';
// import logo from '../assets/images/logo.png';

const Preloader = () => {
    return (
        <>
            <div className='preloader-wrapper'>
                <div className="loader"></div>
            </div>        
        </>
    )
}
export default Preloader;